import React, { useState } from 'react';
import { connect } from 'react-redux';

import {
  Container,
  DateContainer,
} from '../styles';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import RangeDatePicker from '../../../../../components/RangeDatePicker';
import { toISODate, toYyyyMmDd } from '../../../../../utils/parsers-formatters';

const DateFilter = ({
  isOpen,
  onClick,
  onApply,
  initialPeriod,
  finalPeriod,
}) => {
  const [startDate, setStartDate] = useState(toYyyyMmDd(initialPeriod));
  const [endDate, setEndDate] = useState(toYyyyMmDd(finalPeriod));

  const handleSubmit = e => {
    e.preventDefault();

    onApply({
      initialDate: toISODate(startDate),
      finalDate: toISODate(endDate),
    });
  };

  return (
    <FilterContainer label="Período" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por data"
        onSubmit={handleSubmit}
        dontShowClearButton
      >
        <Container>
          <DateContainer>
            <RangeDatePicker
              startDate={startDate}
              endDate={endDate}
              onChangeStartDate={setStartDate}
              onChangeEndDate={setEndDate}
            />
          </DateContainer>
        </Container>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => ({
  initialPeriod: state.carbon.filters.initialPeriod,
  finalPeriod: state.carbon.filters.finalPeriod,
});

export default connect(mapStateToProps)(DateFilter);
